import { Modal, ModalProps } from 'antd';

type ConfirmDeleteModal = {
  modalData: ModalProps;
};

export default function ConfirmDeleteModal({ modalData }: ConfirmDeleteModal) {
  return <Modal {...modalData} okText="확인" okButtonProps={{ danger: true }} cancelText="닫기" />;
}
